import React, { useEffect, useRef, useState } from "react";
import CssTransition from "../../../component/layout/css-transition";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import CustomeModal from "../../../component/modal-popup/customeModal";
import { getAssetTypesForOnboarding } from "../../../redux/actions/onboarding";
import { getIsoData } from "../../../redux/actions/asset";
import Select from "react-select";
import { sanitizeInput } from "../../../utils";

const schema = yup.object({
  asset_type: yup
    .string()
    .required("Asset name is required.")
    // .matches(/^[^\s]+(?:$|.*[^\s]+$)/, "Blank space not allowed in asset type.")
    .max(100, "Asset type must be equal or less than 100 characters."),
  asset_type_option: yup.string().required("Asset type is required."),
  iso_group_code: yup.string(),
});

export default function AddAssetModal({
  id,
  modalOpen,
  setModalOpen,
  _handleSubmit,
}) {
  const modalContent = useRef(null);
  const dispatch = useDispatch();
  const { asset_type_for_onboarding } = useSelector(
    (state) => state.onboarding
  );
  const { isoCodeData } = useSelector((state) => state.assets);
  const { control, handleSubmit, reset, setValue } = useForm({
    resolver: yupResolver(schema),
  });
  const [asset_type, setAsset_type] = useState([]);
  const [type, setType] = useState("");
  const [isoCodeValue, setIsoCodeValue] = useState();
  const [isoCodeOptions, setIsoCodeOptions] = useState([]);

  useEffect(() => {
    getAssetType();
  }, []);

  useEffect(() => {
    if (modalOpen) {
      dispatch(getIsoData());
    }
  }, [modalOpen]);

  useEffect(() => {
    if (isoCodeData.length > 0) {
      const modifiedIsoCodeData = isoCodeData.map((item) => {
        const obj = {
          label: item.iso_group_name,
          value: item.iso_group_code,
        };
        return obj;
      });
      setIsoCodeOptions(modifiedIsoCodeData);
    }
  }, [isoCodeData]);

  useEffect(() => {
    if (asset_type_for_onboarding.length > 0) {
      const arr = [];
      asset_type_for_onboarding.map((item) => {
        const obj = {
          label: item.validation_name,
          value: item.validation_id,
        };
        arr.push(obj);
      });
      arr.push({ label: "Other", value: null });
      setAsset_type(arr);
    }
  }, [asset_type_for_onboarding]);

  const getAssetType = () => {
    const request = {
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getAssetTypesForOnboarding(request));
  };

  const onSunmit = (data) => {
    const payload = {
      validation_id: type.value,
      asset_type: data.asset_type.trim(),
      asset_type_option: data.asset_type_option,
      iso_group_code: data.iso_group_code,
    };

    _handleSubmit(payload);
    setModalOpen(false);
    reset({
      asset_type: "",
      asset_type_option: "",
      iso_group_code: "",
    });
    setType("");
    setIsoCodeValue(null);
  };
  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        id={id}
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className="bg-white w-full overflow-auto max-w-lg max-h-full rounded shadow-lg flex flex-col"
        >
          <div class="py-8 px-6 ">
            <h3 class="mb-8 text-xl font-medium text-gray-900 flex justify-center">
              Add Asset
            </h3>
            <form onSubmit={handleSubmit(onSunmit)}>
              <Controller
                name="asset_type"
                control={control}
                defaultValue=""
                render={({ field: { ref, onChange, ...field }, formState }) => (
                  <div className="mb-5">
                    <label
                      className="block text-sm font-medium mb-1"
                      htmlFor="name"
                    >
                      Asset Name<span className="text-rose-500">*</span>
                    </label>
                    <input
                      ref={(ref) => {
                        if (ref) ref.focus();
                      }}
                      {...field}
                      onChange={(e) => {
                        const value = sanitizeInput(e.target.value);
                        setValue("asset_type", value);
                      }}
                      className="form-input w-full"
                      placeholder="Enter Asset Name"
                      type="text"
                    />
                    {formState.errors?.asset_type && (
                      <div className="text-xs text-rose-600 pt-1 pl-1">
                        {formState.errors?.asset_type?.message}
                      </div>
                    )}
                  </div>
                )}
              />
              <Controller
                name="asset_type_option"
                defaultValue=""
                control={control}
                render={({ field, formState }) => (
                  <div className="mb-5">
                    <label
                      for="asset_type_option"
                      class="block mb-2 text-sm font-medium text-gray-900 "
                    >
                      Asset Type<span className="text-rose-500">*</span>
                    </label>
                    <Select
                      className="basic-single text-sm unresetText"
                      classNames={{
                        control: (style) => {
                          return `!border !shadow-sm ${
                            style.isFocused
                              ? "!border-[--bg-color-300]/50"
                              : "!border-slate-200 hover:!border-gray-300"
                          }`;
                        },
                        container: (style) => {
                          return "!h-[37.5px] !font-inter !text-sm";
                        },
                        menuList: (style) => {
                          return `!max-h-[200px]`;
                        },
                      }}
                      classNamePrefix="select"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      name="asset_type"
                      value={type}
                      placeholder="Select Asset Type"
                      options={asset_type}
                      onChange={(e) => {
                        setType(e);
                        setValue("asset_type_option", e.label);
                      }}
                    />
                    {field.value === "" &&
                      formState.errors?.asset_type_option && (
                        <div className="text-xs text-rose-600 pt-1 pl-1">
                          {formState.errors?.asset_type_option?.message}
                        </div>
                      )}
                  </div>
                )}
              />
              <Controller
                name="iso_group_code"
                defaultValue=""
                control={control}
                render={({ field, formState }) => (
                  <div className="mb-5">
                    <label
                      for="iso_group_code"
                      class="block mb-2 text-sm font-medium text-gray-900 "
                    >
                      ISO Code
                    </label>
                    <Select
                      className="basic-single text-sm unresetText"
                      classNames={{
                        control: (style) => {
                          return `!border !shadow-sm ${
                            style.isFocused
                              ? "!border-[--bg-color-300]/50"
                              : "!border-slate-200 hover:!border-gray-300"
                          }`;
                        },
                        container: (style) => {
                          return "!h-[37.5px] !font-inter !text-sm";
                        },
                        menuList: (style) => {
                          return `!max-h-[200px]`;
                        },
                      }}
                      classNamePrefix="select"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      name="iso_group_code"
                      value={isoCodeValue}
                      placeholder="Select ISO Code"
                      options={isoCodeOptions}
                      onChange={(e) => {
                        setIsoCodeValue(e);
                        setValue("iso_group_code", e.value);
                      }}
                      isDisabled
                    />
                    {field.value === "" && formState.errors?.iso_group_code && (
                      <div className="text-xs text-rose-600 pt-1 pl-1">
                        {formState.errors?.iso_group_code?.message}
                      </div>
                    )}
                  </div>
                )}
              />
              <div class="flex justify-end space-x-2">
                <button
                  type="button"
                  className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600"
                  onClick={() => {
                    setModalOpen(false);
                    reset({
                      asset_type: "",
                      asset_type_option: "",
                      iso_group_code: "",
                    });
                    setType("");
                    setIsoCodeValue("");
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
                  type="Submit"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      </CssTransition>
    </>
  );
}
